import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { Router } from '@angular/router';
import { mergeMap, flatMap, catchError, map, debounce, debounceTime } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { ICheckRegisterRequiredRequest, ICheckRegisterRequiredResponse } from '../../../core/models/check-registration.model';
import { concat, of } from 'rxjs';
import * as checkRegistration from '../actions/check-if-registered.actions';

@Injectable()
export class CheckIfRegisteredEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router
  ) {}

  checkRegisterRequired$ = createEffect(() =>
    this.actions$.pipe(
      ofType(checkRegistration.checkRegisterRequiredRequest),
      mergeMap(action =>
        this.networkCallService
          .post<
            ICheckRegisterRequiredRequest,
            ICheckRegisterRequiredResponse
          >('/Authentication/checkIfBusinessRegistrationRequired', action.request)
          .pipe(
            debounceTime(1000),
            map(response => checkRegistration.checkRegisterRequiredSuccess({ response })),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(checkRegistration.checkRegisterRequiredFailure(error));
            })
          )
      )
    )
  );
}
